import type { WebhookPartsFragment } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteModal from 'src/components/delete-modal';

interface Props {
  webhooks: WebhookPartsFragment[];
  isVisible: boolean;
  onDismiss: () => void;
  onDelete: () => void;
  loading: boolean;
}

export const DeleteWebhookModal: FC<Props> = ({
  webhooks,
  isVisible,
  onDismiss,
  onDelete,
  loading,
}) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'webhooks.delete_modal',
  });

  return (
    <DeleteModal
      isVisible={isVisible}
      onDelete={onDelete}
      onDismiss={onDismiss}
      header={t('title', { count: webhooks.length })}
      loading={loading}
      deleteButtonLabel={t('delete_button')}
    >
      {t('confirm_message', { count: webhooks.length })}
    </DeleteModal>
  );
};

export default DeleteWebhookModal;
